import { useEffect } from 'react'
import { initMetaPixel } from '../utils/metaPixel'

const INTERACTIONS = ['pointerdown', 'keydown', 'scroll', 'touchstart'] as const
const IDLE_TIMEOUT_MS = 2500

/**
 * Carga el Meta Pixel fuera de la ruta crítica: se inicializa en el primer
 * hueco libre del navegador o en la primera interacción del visitante, lo que
 * ocurra antes. Así el script de Facebook (≈70 KiB) no compite con el LCP,
 * pero el PageView se sigue registrando en todas las visitas reales.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    let done = false

    const start = () => {
      if (done) return
      done = true
      cleanup()
      initMetaPixel()
    }

    const cleanup = () => {
      INTERACTIONS.forEach((event) =>
        window.removeEventListener(event, start, { capture: true }),
      )
      window.clearTimeout(timeout)
    }

    INTERACTIONS.forEach((event) =>
      window.addEventListener(event, start, {
        capture: true,
        once: true,
        passive: true,
      }),
    )

    const timeout = window.setTimeout(() => {
      const idle = (
        window as typeof window & {
          requestIdleCallback?: (cb: () => void) => void
        }
      ).requestIdleCallback
      if (idle) idle(start)
      else start()
    }, IDLE_TIMEOUT_MS)

    return cleanup
  }, [])
}
